import React, { Component } from "react"
import { compose } from "recompact"
import entity from "src/engine/modules/entity/hocs/transport"

function transformData(nextProps) {
  const { to } = nextProps

  return nextProps[to].data
}

export default config =>
  compose(
    entity(
      Object.assign(config, {
        plugins: [
          {
            connect: compose(
              BaseComponent =>
                class NestedOnChangeProps extends Component {
                  constructor(...args) {
                    super(...args)

                    this.cachedData = transformData(this.props)
                  }

                  // eslint-disable-next-line camelcase
                  UNSAFE_componentWillReceiveProps(nextProps) {
                    const { props } = this

                    /* Convert data properties by model */
                    if (props[props.to].data !== nextProps[nextProps.to].data) {
                      this.cachedData = transformData(nextProps)
                    }
                  }

                  render() {
                    const { props } = this
                    const nextProps = {
                      ...props,
                      [props.to]: {
                        ...props[props.to],
                        data: this.cachedData,
                      },
                    }
                    return <BaseComponent {...nextProps} />
                  }
                },
            ),
          },
        ].concat(config.plugins || []),
      }),
    ),
  )
